export class UserActivityReport {
  userActivity: UserActivity [];
  companyBusinessPremisesReport: CompanyBusinessPremisesReport [];
  baseLine: string;
  taxAmount: string;
  total: string;

  constructor(data: any) {
    if (data) {
      Object.assign(this, data);
      this.userActivity = data.userActivities.map( value => new UserActivity(value) );
      this.companyBusinessPremisesReport = data.companyBusinessPremises.map( value => new CompanyBusinessPremisesReport(value) );
    }
  }
}

export class UserActivity {
  ticketNumber: string;
  departureTimestamp: string;
  transactionTimestamp: string;
  routeLine: string;
  originStation: string;
  destinationStation: string;
  firstName: string;
  lastName: string;
  price: number;
  discount: string;
  baseLine: number;
  taxAmount: number;
  ticketName: string;
  user: string;
  companyBusinessPremise: string;
  userActivityType: number;
  userActivityTypeName: string;

  constructor(data: any) {
    if (data) {
      Object.assign(this, data);
      if( this.userActivityType == 0 ){
        this.userActivityTypeName = 'Prodaja karte';
      } else if( this.userActivityType == 1 ){
        this.userActivityTypeName = 'Povrat karte';
      } else if( this.userActivityType == 2 ){
        this.userActivityTypeName = 'Prodaja rezervacije';
      } else if( this.userActivityType == 3 ){
        this.userActivityTypeName = 'Tuđa karta / Prodaja rezervacije';
      }
      else if( this.userActivityType == 4 ) {
        this.userActivityTypeName = 'Tuđa karta / Povrat rezervacije';
      }
      else {
        this.userActivityTypeName = 'Povrat rezervacije';
      }
    }
  }
}

export class CompanyBusinessPremisesReport {
  baseLine: string;
  taxAmount: string;
  total: string;
  userReportSum: UserReportSum;
  ticketSold: number;
  name: string;

  oneWayTicketSoldCompany : number;
  twoWayTicketSoldCompany : number;
  segmentTicketSoldCompany : number;
  reservationTicketSoldCompany : number;
  reservationExternalTicketSoldCompany : number;
  reservationExternalTicketReturnSoldCompany : number;
  ticketReturnNumberCompany : number;
  reservationReturnNumberCompany : number;

  oneWayTicketTotalCompany: number;
  twoWayTicketTotalCompany: number;
  segmentTicketTotalCompany: number;
  reservationTicketTotalCompany: number;
  reservationExternalTicketTotalCompany: number;
  reservationExternalTicketReturnTotalCompany: number;
  ticketReturnNumberTotalCompany: number;
  reservationReturnNumberTotalCompany: number;

  constructor(data: any) {
    if (data) {
      Object.assign(this, data);
      this.userReportSum = new UserReportSum(data) ;
    }
  }
}

export class UserReportSum {
  name: string;
  baseLine?: any;
  taxAmount?: any;
  total: any;
  ticketSold?: any;
  oneWayTicketSold?: any;
  oneWayTotal?: any;

  twoWayTicketSold?: any;
  twoWayTotal?: any;

  segmentTicketSold?: any;
  segmentTotal?: any;

  reservationTicketSold?: any;
  reservationTotal?: any;

  ticketReturnNumber?: any;
  ticketReturnTotal?: any;

  reservationReturnNumber?: any;
  reservationReturnTotal?: any;

  reservationExternalTicketSold?: any;
  reservationExternalTotal?: any;

  reservationExternalTicketReturnSold?: any;
  reservationExternalReturnTotal?: any;

  users: UserReport;

  constructor(data: any) {
    if (data) {
      Object.assign(this, data);
      this.users = data.users.map( value => new UserReport(value) );
    }
  }

}

export class UserReport {
  userData: string;
  baseLine?: any;
  taxAmount?: any;
  ticketSold: number;
  ticketPriceTotal: number;
  constructor(data: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/model/UserActivity.ts